import { TOOL_CATEGORIES, ToolCategory } from "../toolRegistry"

export default function CategoryTabs({ activeCategory }: { activeCategory?: ToolCategory }) {
  return (
    <div className="flex overflow-x-auto gap-2 pb-2 scrollbar-hide pt-1">
      {(Object.entries(TOOL_CATEGORIES) as [ToolCategory, typeof TOOL_CATEGORIES[ToolCategory]][]).map(([cat, def]) => {
        const isActive = activeCategory === cat
        return (
          <div
            key={cat}
            className={`whitespace-nowrap px-4 py-2 rounded-full border text-sm font-medium transition-colors ${
              isActive
                ? "bg-primary text-white border-primary"
                : "bg-white text-slate-600 border-slate-200"
            }`}
          >
            {def.label}
          </div>
        )
      })}
    </div>
  )
}
